import { LoadChildrenCallback } from '@angular/router';

type NavigationType = {
  name: string;
  path: string;
  url?: string;
  iconComponent: { name: string };
  loadChildren: LoadChildrenCallback;
};

/**
 * Allow us to write one time the routing for all the applications (for the admin of other stuff)
 * This file is used inside app-routing.module.ts and _nav.ts
 *
 * @see ./app/containers/default-layout/_nav.ts
 * @see ./app/app-routing.module.ts
 */
export const navigations: NavigationType[] = [
  {
    name: 'Utilisateurs',
    path: 'users',
    url: '',
    iconComponent: { name: 'cil-user' },
    loadChildren: () => import('./views/users/routes').then((m) => m.routes),
  },
  {
    name: 'Applications',
    path: 'applications',
    url: '',
    iconComponent: { name: 'cil-applications-settings' },
    loadChildren: () =>
      import('./views/applications/routes').then((m) => m.routes),
  },
  {
    name: 'Structures',
    path: 'companies',
    url: '',
    iconComponent: { name: 'cil-people' },
    loadChildren: () =>
      import('./views/companies/routes').then((m) => m.routes),
  },
  {
    name: 'Types de produits',
    path: 'product_types',
    url: '',
    iconComponent: { name: 'cil-tags' },
    loadChildren: () =>
      import('./views/product-types/routes').then((m) => m.routes),
  },
  {
    name: 'Types de conditionnement',
    path: 'packaging_types',
    url: '',
    iconComponent: { name: 'cil-layers' },
    loadChildren: () =>
      import('./views/packaging-types/routes').then((m) => m.routes),
  },
  {
    name: 'Journal de sécurité',
    path: 'security_logs',
    url: '',
    iconComponent: { name: 'cil-shield-alt' },
    loadChildren: () =>
      import('./views/security-logs/routes').then((m) => m.routes),
  },
];
